<template>
    <div class="anchor-container">
      <table-card style="margin-top:30px" />
    </div>
</template>

<script>

import { 
tableCard
} from '@/components/broker/kpi'
export default {
  name: "kpi",
  components: {
    tableCard
  },
  data() {
    return {

    };
  },
  computed: {
  },
  mounted(){

  },
  methods: {

  }
};
</script>

<style lang="less" scoped>
.anchor-container {
  width: 100%;

}
</style>
